<template>
<div>
    <zm-table v-loading="loading"
        :data="!tableData.length && (filter.status || filter.haStatus) ? [{}] : tableData"
        id="subscriber-table" highlight-current-row @sort-change="onSort"
        border :show-overflow-tooltip="true" :init-displayed-column="initDisplayedColumn" @selection-change="handleSelectSub">
        <zm-table-column type="selection" width="55"></zm-table-column>
        <zm-table-column label="User Name" prop="userName" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="Secret Type" prop="secretType" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="HostName" prop="hostName" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="IP" prop="ip" :show-overflow-tooltip="true" sortable>
            <template slot-scope="scope">
                <ip-cell :group="group" :topicId="topicId" :isPublic="false" @refresh="refresh" :ip="scope.row.ip"
                :allowList="subscriberPrivateIpAllowStrings" :denyList="subscriberPrivateIpDenyStrings"></ip-cell>
            </template>
        </zm-table-column>
        <zm-table-column label="RequestIp" prop="requestIp" :show-overflow-tooltip="true" sortable>
            <template slot-scope="scope">
                <ip-cell :group="group" :topicId="topicId" :isPublic="true" @refresh="refresh" :ip="scope.row.requestIp"
                :allowList="subscriberPublicIpAllowStrings" :denyList="subscriberPublicIpDenyStrings"></ip-cell>
            </template>
        </zm-table-column>
        <zm-table-column label="ClientId" prop="clientId" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="ConsumeDelayMs" prop="consumeDelayMs"></zm-table-column>
        <zm-table-column label="Counts" prop="counts" width="90px"></zm-table-column>
        <zm-table-column label="ReceiveCounts" prop="receiveCounts"></zm-table-column>
        <zm-table-column label="Status" prop="status">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-dropdown trigger="click" @command="handleStatus">
                    <span class="zm-dropdown-link">
                        {{ filter.status || 'Status' }}<i class="zm-icon-down zm-icon--right"></i>
                    </span>
                    <zm-dropdown-menu slot="dropdown">
                        <zm-dropdown-item command="">All</zm-dropdown-item>
                        <zm-dropdown-item command="STARTED">STARTED</zm-dropdown-item>
                        <zm-dropdown-item command="WORKING">WORKING</zm-dropdown-item>
                        <zm-dropdown-item command="ERROR">ERROR</zm-dropdown-item>
                        <zm-dropdown-item command="SHUTDOWN">SHUTDOWN</zm-dropdown-item>
                        <zm-dropdown-item command="ONHOLD">ONHOLD</zm-dropdown-item>
                        <zm-dropdown-item command="STOPPED">STOPPED</zm-dropdown-item>
                        <zm-dropdown-item command="PAUSED">PAUSED</zm-dropdown-item>
                        <zm-dropdown-item command="UNKNOWN">UNKNOWN</zm-dropdown-item>
                        <zm-dropdown-item command="INITIAL">INITIAL</zm-dropdown-item>
                    </zm-dropdown-menu>
                </zm-dropdown>
            </template>
            <template slot-scope="scope">
                {{ scope.row.status }}
                <zm-tooltip
                    placement="top-start"
                    v-if="scope.row.status === 'ERROR'">
                    <div slot="content">
                        <div v-for="item in scope.row.errorMessage.split('\n\t')" :key="item">{{item}}</div>
                    </div>
                    <zm-button size="small" class="btn-contain" type="icon" icon="zm-icon-warning"></zm-button>
                </zm-tooltip>
            </template>
        </zm-table-column>
        <zm-table-column label="HAStatus" prop="haStatus">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-dropdown trigger="click" @command="handleHaStatus">
                    <span class="zm-dropdown-link">
                        {{ filter.haStatus || 'HAStatus' }}<i class="zm-icon-down zm-icon--right"></i>
                    </span>
                    <zm-dropdown-menu slot="dropdown">
                        <zm-dropdown-item command="">ALL</zm-dropdown-item>
                        <zm-dropdown-item command="MASTER">MASTER</zm-dropdown-item>
                        <zm-dropdown-item command="BACKUP">BACKUP</zm-dropdown-item>
                        <zm-dropdown-item command="UNAVAILABLE">UNAVAILABLE</zm-dropdown-item>
                    </zm-dropdown-menu>
                </zm-dropdown>
            </template>
        </zm-table-column>
        <zm-table-column label="dcName" prop="dcName"></zm-table-column>
        <zm-table-column label="Version" prop="version" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="Client Version" prop="clientVersion" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="Client Param" prop="clientParam">
            <template slot-scope="scope">
                <zm-tooltip placement="right" v-if="scope.row.clientParametersResult">
                  <div slot="content">
                    <p v-for="(value, index) in scope.row.clientParametersResult" :key="index">{{ index }}: {{
                        value
                      }}</p>
                  </div>
                  <zm-tag size="medium" type="">{{ scope.row.clientParametersResult.name }}</zm-tag>
                </zm-tooltip>
                <span v-else></span>
            </template>
        </zm-table-column>
        <zm-table-column label="taskPoolFull" prop="taskPoolFull">
            <template slot-scope="scope">
                <i class='glyphicon'
                :class="{'zm-icon-ok':scope.row.taskPoolFull,'zm-icon-close':!scope.row.taskPoolFull}"
                v-if="scope.row.taskPoolFull !== undefined"></i>
            </template>
        </zm-table-column>
        <zm-table-column label="IsConsoleStartConsumer" prop="isConsoleStartConsumer">
            <template slot-scope="scope">
                <i class='glyphicon'
                :class="{'zm-icon-ok':scope.row.isConsoleStartConsumer,'zm-icon-close':!scope.row.isConsoleStartConsumer}"
                v-if="scope.row.isConsoleStartConsumer !== undefined"></i>
            </template>
        </zm-table-column>
        <zm-table-column label="IsDiscard" prop="isDiscard">
            <template slot-scope="scope">
                <i class='glyphicon'
                :class="{'zm-icon-ok':scope.row.isDiscard,'zm-icon-close':!scope.row.isDiscard}"
                v-if="scope.row.isDiscard !== undefined"></i>
            </template>
        </zm-table-column>
        <zm-table-column label="IsPaused" prop="isPaused">
            <template slot-scope="scope">
                <i class='glyphicon'
                :class="{'zm-icon-ok':scope.row.isPaused,'zm-icon-close':!scope.row.isPaused}"
                v-if="scope.row.isPaused !== undefined"></i>
            </template>
        </zm-table-column>
        <zm-table-column label="SSLEnable" prop="SSLEnable">
            <template slot-scope="scope">
                <i class='glyphicon'
                :class="{'zm-icon-ok':scope.row.SSLEnable,'zm-icon-close':!scope.row.SSLEnable}"
                v-if="scope.row.SSLEnable !== undefined"></i>
            </template>
        </zm-table-column>
        <zm-table-column label="Receive Threads Status" prop="receiveThreadsStatus">
            <template slot-scope="scope">
                <zm-tooltip placement="right"
                v-if="scope.row.receiveThreadsStatus && Object.keys(scope.row.receiveThreadsStatus).length">
                    <div slot="content">
                        <p v-for="(value, index) in scope.row.receiveThreadsStatus" :key="index">
                            {{index}}: {{ new Date(parseInt(value)).toLocaleString() }}
                        </p>
                    </div>
                    <zm-tag size="medium" type="">show</zm-tag>
                </zm-tooltip>
                <span v-else></span>
            </template>
        </zm-table-column>
        <zm-table-column label="Receive Threads Info" prop="receiveThreadsInfo">
            <template slot-scope="scope">
                <zm-tooltip placement="left" popper-class="consumeThreadsInfo-tooltip"
                v-if="scope.row.receiveThreadsInfo && Object.keys(scope.row.receiveThreadsInfo).length">
                    <div slot="content">
                        <thread-info keyLabel="threadIndex" :data="scope.row.receiveThreadsInfo"></thread-info>
                        <!-- <p v-for="(value, index) in scope.row.receiveThreadsInfo" :key="index">
                            {{ new Date(parseInt(value.lastWorkingTime)).toLocaleString() }}
                            <span v-if="value.lastWorkingTaskId">: </span>
                            <a :href="'/#/dashboard/task?id=' + value.lastWorkingTaskId" target="_blank">{{ value.lastWorkingTaskId }}</a>
                        </p> -->
                    </div>
                    <zm-tag size="medium" type="">show</zm-tag>
                </zm-tooltip>
                <span v-else></span>
            </template>
        </zm-table-column>
        <zm-table-column label="Consume Threads Status" prop="consumeThreadsStatus">
            <template slot-scope="scope">
                <zm-tooltip placement="right"
                v-if="scope.row.consumeThreadsStatus && Object.keys(scope.row.consumeThreadsStatus).length">
                    <div slot="content">
                        <p v-for="(value, index) in scope.row.consumeThreadsStatus" :key="index">
                            {{index}}: {{ new Date(parseInt(value)).toLocaleString() }}
                        </p>
                    </div>
                    <zm-tag size="medium" type="">show</zm-tag>
                </zm-tooltip>
                <span v-else></span>
            </template>
        </zm-table-column>
        <zm-table-column label="Consume Threads Info" prop="consumeThreadsInfo">
            <template slot-scope="scope">
                <zm-tooltip placement="left" popper-class="consumeThreadsInfo-tooltip"
                v-if="scope.row.consumeThreadsInfo && Object.keys(scope.row.consumeThreadsInfo).length">
                    <div slot="content">
                        <thread-info keyLabel="threadIndex" :data="scope.row.consumeThreadsInfo"></thread-info>
                        <!-- <p v-for="(value, index) in scope.row.consumeThreadsInfo" :key="index">
                            {{ new Date(parseInt(value.lastWorkingTime)).toLocaleString() }}
                            <span v-if="value.lastWorkingTaskId">: </span>
                            <a :href="'/#/dashboard/task?id=' + value.lastWorkingTaskId" target="_blank">{{ value.lastWorkingTaskId }}</a>
                        </p> -->
                    </div>
                    <zm-tag size="medium" type="">show</zm-tag>
                </zm-tooltip>
                <span v-else></span>
            </template>
        </zm-table-column>
        <zm-table-column label="Task Thread Info" prop="taskThreadInfo">
            <template slot-scope="scope">
                <zm-tooltip placement="left" popper-class="consumeThreadsInfo-tooltip"
                v-if="scope.row.taskThreadInfo && Object.keys(scope.row.taskThreadInfo).length">
                    <div slot="content">
                        <thread-info keyLabel="taskId" :data="scope.row.taskThreadInfo"></thread-info>
                    </div>
                    <zm-tag size="medium" type="">show</zm-tag>
                </zm-tooltip>
                <span v-else></span>
            </template>
        </zm-table-column>
        <zm-table-column label="Registered Handlers" prop="registeredHandlers">
            <template slot-scope="scope">
                <zm-tooltip placement="right"
                v-if="scope.row.registeredHandlers && scope.row.registeredHandlers.length">
                    <div slot="content">
                        <p v-for="item in scope.row.registeredHandlers" :key="item">{{ item }}</p>
                    </div>
                    <zm-tag size="medium" type="">show</zm-tag>
                </zm-tooltip>
                <span v-else></span>
            </template>
        </zm-table-column>
        <zm-table-column label="Restart Counts" prop="restartCounts" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="CreatedTime" prop="createdTime" :formatter="setTime" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="Record Time" prop="recordTime" :formatter="setTime" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="ModifiedTime" prop="modifiedTime" :formatter="setTime" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column prop="action" width="150px" align="center" fixed="right">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-button size="small" class="btn-contain" type="icon" title="batch delete subscriber" icon="zm-icon-delete" @click="batchDeleteSub()" :disabled="!selectedSubIds.length"></zm-button>
            </template>
            <template slot-scope="scope">
                <zm-button size="small" class="btn-contain" type="icon" title="edit subscriber" icon="zm-icon-edit" @click="showEdit(scope.row)" :loading="editLoading"></zm-button>
                <zm-button size="small" class="btn-contain" type="icon" title="refresh subscriber" icon="zm-icon-refresh" @click="refreshSub(scope.row)"></zm-button>
                <zm-button size="small" class="btn-contain iconfont icon-re-start" type="icon" title="restart subscriber" @click="restartSub(scope.row)" :loading="restartLoading">
                    <i class=""></i>
                </zm-button>
            </template>
        </zm-table-column>
    </zm-table>
    <div style="text-align: center" class="pagination-wrap">
        <zm-pagination @current-change="paginationChange"
            @size-change="handleSizeChange"
            :current-page.sync="pageable.page"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pageable.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageable.total">
        </zm-pagination>
    </div>
    <zm-dialog title="Subscriber Settings" :visible.sync="dialogVisible" :append-to-body="true" width="450px">
        <zm-form :model="form" label-position="left" ref="form">
            <zm-form-item label="counts" label-width="100px" prop="settingCounts">
                <div slot="label">
                    <tip label="counts" id="topic-subscriber-counts"></tip>
                </div>
                <zm-input-number size="small" v-model="form.settingCounts" :min="0"></zm-input-number>
            </zm-form-item>
            <zm-form-item label="receiveCounts" label-width="100px" prop="settingReceiveCounts">
                <div slot="label">
                    <tip label="receiveCounts" id="topic-subscriber-receiveCounts"></tip>
                </div>
                <zm-input-number size="small" v-model="form.settingReceiveCounts" :min="0"></zm-input-number>
            </zm-form-item>
            <zm-form-item label="status" label-width="100px">
                <div slot="label">
                    <tip label="status" id="topic-subscriber-status"></tip>
                </div>
                <zm-select size="small" v-model="form.settingStatus">
                    <zm-option v-for="item in options" :key="item.value"
                    :disabled="item.disabled"
                    :label="item.value" :value="item.value"></zm-option>
                    <!-- <zm-option label="RESTART" value="RESTART"></zm-option> -->
                </zm-select>
            </zm-form-item>
            <zm-form-item label="createdTime" label-width="100px">
                <div slot="label">
                    <tip label="createdTime" id="topic-subscriber-createdTime"></tip>
                </div>
                <zm-date-picker size="small" type="datetime" v-model="timeForm.settingCreatedTime" readonly></zm-date-picker>
            </zm-form-item>
            <zm-form-item label="modifiedTime" label-width="100px">
                <div slot="label">
                    <tip label="modifiedTime" id="topic-subscriber-modifiedTime"></tip>
                </div>
                <zm-date-picker size="small" type="datetime" v-model="timeForm.settingModifiedTime" readonly></zm-date-picker>
            </zm-form-item>
        </zm-form>
        <div slot="footer" class="dialog-footer">
            <zm-button size="small" @click="dialogVisible = false">Cancel</zm-button>
            <zm-button size="small" type="primary" @click="resetSub()" :loading="resetLoading">Reset</zm-button>
            <zm-button size="small" type="primary" @click="save()" :loading="saveLoading">Submit</zm-button>
        </div>
    </zm-dialog>
</div>
</template>
<script>
import { batchDeleteSub, getTopicSubscriber, refreshSubscriber, updateSubscriber } from '../../api/index'
import tip from 'components/ToolTip/index'
import threadInfo from './threadInfo'
import ipCell from './ipCell'
export default {
    name: 'subscriber',
    components: { tip, threadInfo, ipCell },
    data () {
        return {
            list: [],
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'subscriber',
                props: ['userName', 'ip', 'clientId', 'counts', 'receiveCounts', 'status', 'haStatus', 'dcName', 'version', 'clientVersion', 'taskPoolFull', 'receiveThreadsStatus', 'consumeThreadsStatus', 'Restart Counts', 'recordTime', 'createdTime', 'modifiedTime', 'action']
            },
            loading: false,
            resetLoading: false,
            saveLoading: false,
            editLoading: false,
            restartLoading: false,
            filter: {
                status: '',
                haStatus: ''
            },
            selectedSubIds: [],
            form: {
                id: '',
                settingCounts: '',
                settingReceiveCounts: '',
                settingStatus: '',
                clientVersion: '',
                group: '',
                ip: '',
                clientId: '',
                status: '',
                topicId: '',
                userId: ''
            },
            timeForm: {
                settingCreatedTime: '',
                settingModifiedTime: ''
            },
            dialogVisible: false,
            pageable: {
                total: 0,
                page: 1,
                size: 10
            },
            options: [
                // {
                //     disabled: true,
                //     value: 'INITIAL'
                // },
                {
                    disabled: false,
                    value: 'FORBIDDEN'
                },
                {
                    disabled: false,
                    value: 'ALLOWED'
                }
            ]
        }
    },
    props: ['topicId', 'group', 'subscriberPrivateIpAllowStrings', 'subscriberPrivateIpDenyStrings', 'subscriberPublicIpAllowStrings', 'subscriberPublicIpDenyStrings'],
    computed: {
        tableData () {
            const { status, haStatus } = this.filter
            if (status && haStatus) {
                return this.list.filter(data => {
                    return data.status === status && data.haStatus === haStatus
                })
            } else if (status) {
                return this.list.filter(data => {
                    return data.status === status
                })
            } else if (haStatus) {
                return this.list.filter(data => {
                    return data.haStatus === haStatus
                })
            }
            return this.list
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        refresh () {
            this.$emit('refreshSubscriberList')
        },
        fetchData () {
            this.loading = true
            getTopicSubscriber(this.topicId, this.group, this.pageable.size, this.pageable.page - 1, this.filter.status, this.filter.haStatus).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSelectSub (val) {
            this.selectedSubIds = []
            val.map(item => {
                this.selectedSubIds.push(item.id)
            })
        },
        batchDeleteSub () {
            const ids = this.selectedSubIds
            this.loading = true
            this.$confirm('This will permanently batch delete the subscribers. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                batchDeleteSub(ids).then(response => {
                    this.loading = false
                    this.selectedSubIds = []
                    this.$message({
                        message: 'Delete subscriber success!',
                        type: 'success'
                    })
                    this.$emit('refreshSubscriberList')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showEdit (row) {
            // this.options.map(e => {
            //     e.disabled = false
            // })
            this.refreshSub(row, true)
            this.form.id = row.id
            this.form.clientVersion = row.clientVersion
            this.form.group = row.group
            this.form.topicId = this.topicId
            this.form.ip = row.ip
            this.form.clientId = row.clientId
            this.form.status = row.status
            this.form.userId = row.userId
            // if (this.form.settingStatus !== 'INITIAL') {
            //     this.options[0].disabled = true
            // }
        },
        restartSub (row) {
            this.$confirm('This will restart the subscriber. Continue?', 'Warning', {
                confirmButtonText: 'Restart',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.form.id = row.id
                this.form.clientVersion = row.clientVersion
                this.form.group = row.group
                this.form.topicId = this.topicId
                this.form.ip = row.ip
                this.form.clientId = row.clientId
                this.form.status = row.status
                this.form.userId = row.userId
                this.restartLoading = true
                refreshSubscriber(row.id, row.clientId, this.topicId, row.group, row.userId).then(response => {
                    this.list.map(sub => {
                        if (sub.id === row.id) {
                            this.form.settingCounts = response.settingCounts
                            this.form.settingReceiveCounts = response.settingReceiveCounts
                            this.form.settingStatus = 'RESTART'
                        }
                    })
                    this.save(true, true)
                })
            }).catch(() => {
                this.resetLoading = false
                this.saveLoading = false
                this.$message({
                    type: 'info',
                    message: 'Restart canceled'
                })
            })
        },
        refreshSub (row, showDialog) {
            this.loading = true
            this.editLoading = showDialog || false
            refreshSubscriber(row.id, row.clientId, this.topicId, row.group, row.userId).then(response => {
                this.list.map(sub => {
                    if (sub.id === row.id) {
                        this.form.settingCounts = response.settingCounts
                        this.form.settingReceiveCounts = response.settingReceiveCounts
                        this.timeForm.settingCreatedTime = response.settingCreatedTime
                        this.timeForm.settingModifiedTime = response.settingModifiedTime
                        this.form.settingStatus = response.settingStatus
                        for (var key in response) {
                            if (sub[key] !== null) {
                                sub[key] = response[key]
                            } else if (key === 'haStatus') {
                                sub.haStatus = response[key]
                            }
                            if (row[key] !== null) {
                                row[key] = response[key]
                            } else if (key === 'haStatus') {
                                row.haStatus = response[key]
                            }
                        }
                    }
                })
                this.loading = false
                this.editLoading = false
                this.dialogVisible = showDialog || false
            }).catch(() => {
                this.loading = false
                this.editLoading = false
            })
        },
        resetSub () {
            this.$confirm('This will reset the subscriber. Continue?', 'Warning', {
                confirmButtonText: 'Reset',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.form.settingCounts = 0
                this.form.settingReceiveCounts = 0
                this.form.settingStatus = 'INITIAL'
                this.save(true)
            }).catch(() => {
                this.resetLoading = false
                this.saveLoading = false
                this.$message({
                    type: 'info',
                    message: 'Reset canceled'
                })
            })
        },
        save (isRefresh, isRestart) {
            if (isRefresh) {
                this.resetLoading = true
            } else {
                this.saveLoading = true
            }
            updateSubscriber(this.form).then(response => {
                this.$message({
                    message: isRestart ? 'Restart subscriber success!' : 'Update subscriber success!',
                    type: 'success'
                })
                this.loading = true
                this.dialogVisible = false
                this.resetLoading = false
                this.saveLoading = false
                this.restartLoading = false
                refreshSubscriber(this.form.id, this.form.clientId, this.topicId, this.form.group, this.form.userId).then(res => {
                    this.list.map(data => {
                        data.subscribersData.map(sub => {
                            if (sub.id === this.form.id) {
                                for (var key in res) {
                                    if (sub[key]) {
                                        sub[key] = res[key]
                                    }
                                    if (this.form[key]) {
                                        this.form[key] = res[key]
                                    }
                                }
                            }
                        })
                    })
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.restartLoading = false
                this.dialogVisible = false
                this.resetLoading = false
                this.saveLoading = false
            })
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            if (time) {
                return new Date(parseInt(time)).toLocaleString()
            }
            return ''
        },
        paginationChange () {
            this.fetchData()
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        handleStatus (command) {
            this.filter.status = command
            this.fetchData()
        },
        handleHaStatus (command) {
            this.filter.haStatus = command
            this.fetchData()
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
                if (a[prop] > b[prop]) {
                    return descending ? -1 : 1
                } else if (a[prop] < b[prop]) {
                    return descending ? 1 : -1
                } else {
                    return 0
                }
            })
        }
    }
}
</script>
<style>
@import '../../assets/icons/iconfont.css';
.zm-tooltip__popper {
    word-break: break-all;
    max-width: 880px;
}
.consumeThreadsInfo-tooltip {
    max-height: 50vh;
    min-width: 600px;
    overflow-x: hidden;
    overflow-y: scroll;
}
</style>
